<div class="page-container jurisdiction-page">
  <ul class="nav nav-tabs jurisdiction-tabs mb-3">
    <li class="nav-item">
      <button type="button" class="nav-link" [class.active]="activeTab === 'states'" (click)="setTab('states')">US States</button>
    </li>
    <li class="nav-item">
      <button type="button" class="nav-link" [class.active]="activeTab === 'countries'" (click)="setTab('countries')">Countries</button>
    </li>
  </ul>

  <div class="row mt-2">
    <div class="col-lg-8">
      @if (activeTab === 'states') {
        <div class="d-flex justify-content-end mb-2">
          <app-state-filter-dropdown [color]="'primary'" (stateChange)="filterByState($event)"></app-state-filter-dropdown>
        </div>

        @if (selectedStates.length &&
          statesWithNexusAndAutoFilling.length === 0 &&
          statesWithNexusAndManualFilling.length === 0 &&
          statesWithoutNexus.length === 0) {
          <app-jurisdiction-empty-state
            icon="mdi-filter-off-outline"
            title="No states match your filter"
            message="Try modifying your filters or clear them to view all available states."
            actionLabel="Clear filters"
            (action)="filterByState([])" />
        } @else if (!hasStateContent) {
          <app-jurisdiction-empty-state
            icon="mdi-map-search-outline"
            title="No US state activity yet"
            message="State collection and filing insights will appear once you have qualifying US sales."
            actionLabel="Manage tax jurisdictions"
            actionLink="/account-settings/nexus" />
        } @else {
          @if (statesWithNexusAndAutoFilling.length > 0) {
            <article class="mb-4" id="collecting">
              <h5 class="pb-3 fw-bold">States collecting in &amp; enrolled in auto filing</h5>
              <app-state-tax-card *ngFor="let state of statesWithNexusAndAutoFilling" [collecting]="true" [report]="state"></app-state-tax-card>
            </article>
          }

          @if (statesWithNexusAndManualFilling.length > 0) {
            <article class="mb-4" id="collecting-manual-filling">
              <h5 class="pb-3 fw-bold">States collecting in &amp; filing manually</h5>
              <app-state-tax-card *ngFor="let state of statesWithNexusAndManualFilling" [collecting]="true" [report]="state"></app-state-tax-card>
            </article>
          }

          @if (statesWithoutNexus.length > 0) {
            <article class="mb-4" id="not-collecting">
              <h5 class="pb-3 fw-bold">States where you may have nexus &amp; you have sales transactions</h5>
              <div class="card panel-card mb-3">
                <div class="card-body">
                  <h6 class="mb-2">Steps to get compliant</h6>
                  <ol class="small mb-0">
                    <li>Confirm you have nexus</li>
                    <li>Register to collect</li>
                    <li>Setup your linked accounts</li>
                  </ol>
                </div>
              </div>
              <app-state-tax-card *ngFor="let state of statesWithoutNexus" [collecting]="state.has_nexus" [report]="state"></app-state-tax-card>
              <a class="small fw-bold" routerLink="/account-settings/nexus">Add more jurisdictions <span class="mdi mdi-arrow-right"></span></a>
            </article>
          }
        }
      } @else {
        <div class="d-flex justify-content-end mb-2">
          <app-country-filter-dropdown [color]="'primary'" (countryChange)="filterByCountry($event)"></app-country-filter-dropdown>
        </div>

        @if (selectedCountries.length &&
          countriesWithNexusAndAutoFilling.length === 0 &&
          countriesWithNexusAndManualFilling.length === 0 &&
          countriesWithoutNexus.length === 0) {
          <app-jurisdiction-empty-state
            icon="mdi-filter-off-outline"
            title="No countries match your filter"
            message="Try modifying your filters or clear them to view all available countries."
            actionLabel="Clear filters"
            (action)="filterByCountry([])" />
        } @else if (!hasCountryContent) {
          <app-jurisdiction-empty-state
            icon="mdi-earth-off"
            title="No international activity yet"
            message="Country and province VAT/GST insights will appear once you have international sales."
            actionLabel="Manage tax jurisdictions"
            actionLink="/account-settings/nexus" />
        } @else {
          @if (countriesWithNexusAndAutoFilling.length > 0) {
            <article class="mb-4" id="international-collecting-autofiling">
              <h5 class="pb-3 fw-bold">Countries collecting in &amp; enrolled in auto filing</h5>
              <app-country-tax-card *ngFor="let country of countriesWithNexusAndAutoFilling"
                [collecting]="true"
                [report]="country"
                [startDate]="periodStart"
                [endDate]="periodEnd"></app-country-tax-card>
            </article>
          }

          @if (countriesWithNexusAndManualFilling.length > 0) {
            <article class="mb-4" id="international-collecting">
              <h5 class="pb-3 fw-bold">Countries collecting in &amp; filing manually</h5>
              <app-country-tax-card *ngFor="let country of countriesWithNexusAndManualFilling"
                [collecting]="true"
                [report]="country"
                [startDate]="periodStart"
                [endDate]="periodEnd"></app-country-tax-card>
            </article>
          }

          @if (countriesWithoutNexus.length > 0) {
            <article class="mb-4" id="international-not-collecting">
              <h5 class="pb-3 fw-bold">Countries where you have sales transactions</h5>
              <app-country-tax-card *ngFor="let country of countriesWithoutNexus"
                [collecting]="false"
                [report]="country"
                [startDate]="periodStart"
                [endDate]="periodEnd"></app-country-tax-card>
              <a class="small fw-bold" routerLink="/account-settings/nexus">Add tax jurisdiction <span class="mdi mdi-arrow-right"></span></a>
            </article>
          }
        }
      }
    </div>

    <div class="col-lg-4">
      <div class="card sidebar-card mb-3">
        <div class="card-header">Economic Nexus Insights</div>
        <div class="card-body">
          <p class="small text-muted mb-2">
            See where your business has met or is approaching economic nexus thresholds.
          </p>
          <a class="card-header-action small" routerLink="/economic-nexus">Check economic nexus</a>
        </div>
      </div>

      <div class="card sidebar-card mb-3">
        <div class="card-header">Reconciliation Report</div>
        <div class="card-body">
          <p class="small text-muted mb-2">
            Download a comprehensive summary of your monthly sales tax data.
          </p>
          <a class="card-header-action small" appDownloadFile [url]="reconReportURL" href="javascript:void(0)"
             fileName="atomictax_reconciliation_report_{{salesTaxReport.summary.date.to | isoDate:'MM-DD-YYYY' | date:'yyyy':'EDT'}}.csv">
            Export report
          </a>
        </div>
      </div>

      <div class="card card-body sidebar-stat-card">
        <div class="stat-grid">
          <div>
            <span class="stat-label">Gross sales (YTD)</span>
            <app-amount class="stat-value" [amount]="salesTaxReport.summary.gross"></app-amount>
          </div>
          <div>
            <span class="stat-label">Tax collected (YTD)</span>
            <app-amount class="stat-value stat-value--price" [amount]="salesTaxReport.summary.total_sales_tax_due"></app-amount>
          </div>
        </div>
        <hr class="my-3">
        <p class="sidebar-help mb-1">
          Taxed sales:
          <app-amount [amount]="salesTaxReport.summary.sales_subject_to_sales_tax"></app-amount>
        </p>
        <p class="sidebar-help mb-0">
          <a routerLink="/sales-tax-analysis">Detailed Sales Tax Analysis</a>
        </p>
      </div>
    </div>
  </div>
</div>
